import { TruncatePrice } from "Util/NumberUtils";
import { PaymentSummary } from "Hooks/Api/apiPayment";

type PaymentSummaryContentProps = {
	paymentSummary: PaymentSummary;
	isOrderItemVisible?: boolean;
}

type PaymentSummarySectionProps = {
	title?: string;
	children: React.ReactNode;
}
export function PaymentSummarySection({
	title,
	children
}: PaymentSummarySectionProps) {
	return (
		<div className="payment-summary-section">
			{title && <h3 className="title">{title}</h3>}
			{children}
		</div>
	)
}

PaymentSummarySection.OrderItemAndCalculation = function OrderItemAndCalculation({
	paymentSummary,
	isOrderItemVisible = true,
}: PaymentSummaryContentProps) {
	return (
		<>
			{isOrderItemVisible && paymentSummary.items.length > 0 && (
				<div className="section orderItems">
					{/* TODO: Adapt the design when available from designer */}
					{paymentSummary.items.map((item, index) => (
						<div className="item" key={index}>
							<span><strong>{item.name}</strong></span>
							<span>{item.description}</span>
							<span>${TruncatePrice(item.priceIncGst)}</span>
						</div>
					))}
				</div>
			)}
			<hr />
			<div className="section pricing">
				<div className="item">
					<span>Subtotal:</span>
					<span>${TruncatePrice(paymentSummary.totalAmountExcGst)}</span>
				</div>
				<div className="item">
					<span>GST({paymentSummary.gstRate * 100}%):</span>
					<span>${TruncatePrice(paymentSummary.gstAmount)}</span>
				</div>
				<div className="item">
					<span><strong>Total: </strong></span>
					<span className="total-value"><strong>${TruncatePrice(paymentSummary.totalAmountIncGst)}</strong></span>
				</div>
			</div>
		</>
	)
}